// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32BO4","controls":"styles_controls__EVXk6","charLimit":"styles_charLimit__1LunY","input":"styles_input__22N0r","send":"styles_send__NXf_O"};